import React, { useState } from "react";
import ListCard from "./ListCard";
import { motion } from "framer-motion";
import { springVariants, springViewport } from "../utils/framerVariants";

const Feeds = ({ articles }) => {
  const [visibleArticles, setVisibleArticles] = useState(6); // Show 6 articles initially

  const handleLoadMore = () => {
    setVisibleArticles((prev) => Math.min(prev + 6, articles.length)); // Load 6 more articles
  };

  const isGerman = typeof window !== 'undefined' && window.location.pathname.includes('/de');

  return (
    <div>
      <motion.div
        variants={springVariants}
        initial="invisible"
        whileInView="visible"
        viewport={springViewport}
        className="grid grid-cols-1 feed-list"
      >
        {articles.slice(0, visibleArticles).map((article) => (
          <ListCard article={article} key={`${article.slug}`} />
        ))}
        {visibleArticles < articles.length && (
          <motion.div
            variants={springVariants}
            initial="invisible"
            whileInView="visible"
            viewport={springViewport}
            className="grid grid-cols-1 mt-12"
          >
            <button
              onClick={handleLoadMore}
              className="load-more-btn mt-4 font-semibold py-3.5 pb-4 px-8 bg-black ring-3 ring-black ring-inset text-white inline-block mx-auto rounded-sm transition-all duration-200"
            >
              {isGerman ? "Mehr Laden" : "Load More"}
            </button>
          </motion.div>
        )}
      </motion.div>
    </div>
  );
};

export default Feeds;
